$(document).ready(function(){
    // Agregar evento click a los títulos del acordeón
    $('.accordion-title').click(function(){
        // Si el panel ya está abierto, no hacer nada
        if ($(this).parent().hasClass('active')) {
            return;
        }
        
        // Cerrar todos los paneles abiertos
        $('.accordion-item').removeClass('active');
        $('.accordion-content').slideUp();

        // Abrir el panel clickeado
        $(this).parent().addClass('active');
        $(this).next('.accordion-content').slideDown();

        // Desplazar la página para enfocar el contenido abierto
        $('html, body').animate({
            scrollTop: $(this).offset().top - 200 // Ajustar el desplazamiento según sea necesario
        }, 500); // Duración del desplazamiento en milisegundos
    });
});